import { render, staticRenderFns } from "./detail1.vue?vue&type=template&id=5d552c0c&scoped=true&"
import script from "./detail1.vue?vue&type=script&lang=js&"
export * from "./detail1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d552c0c",
  null
  
)

export default component.exports